import { render, staticRenderFns } from "./dropdown.vue?vue&type=template&id=72ff1868"
import script from "./dropdown.js?vue&type=script&lang=js&external"
export * from "./dropdown.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports